import { IAcquisitionOverview } from "../types/acquisition-overview";

export const initialAcquisitionOverview: IAcquisitionOverview = {
    reason: "",
    explication: "",
    acquisiton_type: "",
    transaction_duration: "",
    business_value: ""
};